export const stories = [
  {
    id: 'dorm-lights-out-radio',
    title: '熄灯后我们宿舍开了档“电台”，收听率比校园广播还高',
    categorySlug: 'dorm',
    categoryName: '宿舍夜聊',
    excerpt:
      '大二那年我们给宿舍夜聊起了个台名，每晚十一点准时开播，隔壁宿舍搬着小板凳来串门，连宿管阿姨都成了固定听众。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20cozy%20university%20dormitory%20at%20night%20with%20warm%20lamp%20light%2C%20students%20chatting%20on%20bunk%20beds%2C%20terracotta%20orange%20and%20cream%20palette%2C%20minimal%20editorial%20style%2C%20soft%20shapes&width=800&height=600&seq=gt-dorm-radio-01&orientation=landscape',
    author: '夜猫编辑·小满',
    date: '2026-09-08',
    readTime: 6,
    views: 18420,
    hot: true,
    featured: true,
    tags: ['宿舍夜聊', '熄灯后', '室友关系'],
    content: [
      { type: 'p', text: '故事的起点特别朴素：我们宿舍四个人作息完全错开，白天几乎说不上三句话，反而是熄灯后躺在床上，话匣子才“啪”地打开。' },
      { type: 'h3', text: '从一句话到一档节目' },
      { type: 'p', text: '一开始只是随口聊聊今天遇到的离谱事，后来室友阿哲提议给这个环节起个名字，于是“四号楼深夜电台”正式挂牌。每周一到周四，十一点熄灯，十一点零五分开播，内容涵盖今日课堂奇闻、食堂新品测评、以及谁能在一分钟内把一件小事讲成悬疑大片。' },
      { type: 'quote', text: '“我们不是话多，我们只是把白天的沉默攒到了晚上。”——电台台长阿哲' },
      { type: 'h3', text: '意外走红的收听现场' },
      { type: 'p', text: '真正的转折是某天隔壁宿舍来借插线板，站在门口听完了整段“食堂阿姨手抖学分析”，第二天带着三个人准时来旁听。再后来，连查寝的宿管阿姨都会在门口站一会儿，听完当天的话题再走。' },
      { type: 'p', text: '我们没做什么惊天动地的事，只是把每天的碎碎念认真对待了。毕业那天大家收拾行李，才发现这段熄灯后的仪式感，才是大学里最舍不得的东西。' },
    ],
  },
  {
    id: 'class-roll-call-legend',
    title: '我们班有个“点名锦鲤”，一学期只被点到一次还赶上了请假',
    categorySlug: 'class',
    categoryName: '课堂八卦',
    excerpt:
      '这门课的老师用抽签小程序点名，全班的出勤率神奇地维持在一个微妙平衡，直到那位锦鲤同学的传说流传开来。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20university%20lecture%20hall%20with%20students%20raising%20hands%2C%20minimal%20warm%20terracotta%20orange%20and%20cream%20palette%2C%20editorial%20vector%20style%2C%20simple%20clean%20composition&width=800&height=600&seq=gt-class-rollcall-02&orientation=landscape',
    author: '课堂观察员·老周',
    date: '2026-09-06',
    readTime: 5,
    views: 15260,
    hot: true,
    featured: false,
    tags: ['课堂八卦', '点名', '大学生活'],
    content: [
      { type: 'p', text: '事情要从那门“现代社会学导论”说起。老师年纪不大，热衷技术，点名不用花名册，改用抽签小程序，系统随机滚动名字，被抽中的同学站起来回答一个小问题。' },
      { type: 'h3', text: '一个统计学上的奇迹' },
      { type: 'p', text: '第一次抽签就抽中了小林，他刚好感冒请假；第二次、第三次他都在场，却始终没被抽中；到学期末，全班四十多人被抽中的次数相近，唯独小林，一个学期只中了一次，还是他请假那天。' },
      { type: 'p', text: '班里开始流传“点名锦鲤”的说法，有人期末考试前专门来跟他握手，说沾沾运气。小林每次都一脸无奈：“这运气我宁愿用在抢选修课上。”' },
      { type: 'quote', text: '“概率不会骗人，但小林会让我们怀疑概率。”——老师的原话' },
      { type: 'p', text: '学期结束时老师笑着总结：点名不是为了抓人，是想让每个人都开口说一次话。至于锦鲤传说，老师说他查过记录，纯属巧合，但大家显然更愿意相信后者的版本。' },
    ],
  },
  {
    id: 'club-recruiting-disaster',
    title: '百团大战摆摊第一天，我们把自家社团招牌拿反了',
    categorySlug: 'club',
    categoryName: '社团趣事',
    excerpt:
      '纳新现场人山人海，我们几个新干事手忙脚乱挂横幅，直到有同学来问“你们是不是摄影社”，才发现招牌挂倒了。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20university%20student%20club%20fair%20with%20colorful%20booths%20and%20banners%2C%20warm%20orange%20amber%20and%20cream%20palette%2C%20minimal%20editorial%20vector%20style&width=800&height=600&seq=gt-club-booth-03&orientation=landscape',
    author: '社团打工人·阿岩',
    date: '2026-09-04',
    readTime: 5,
    views: 11780,
    hot: false,
    featured: true,
    tags: ['社团趣事', '百团大战', '纳新'],
    content: [
      { type: 'p', text: '每年九月的社团招新，是我们这一年里最忙也最上头的一周。作为刚上任的宣传部干事，我接到的第一个任务就是——把社团横幅挂上去。' },
      { type: 'h3', text: '一场方向感灾难' },
      { type: 'p', text: '清晨六点半，四个人抬着三米长的横幅，在根本没睡醒的状态下系好了绳子。八点人流涌来，我们热情地给路过的同学介绍，讲到口干舌燥，才发现横幅上“定向越野社”几个字是倒过来的。' },
      { type: 'p', text: '更离谱的是，倒着的横幅反而吸引了更多人驻足，大家觉得这个“翻车现场”很可爱，当天报名的同学里有三分之一是被这块招牌逗过来的。' },
      { type: 'quote', text: '“既然翻车也能招到人，那说明我们社团气质对了。”——社长的总结' },
      { type: 'p', text: '后来我们每次活动都会留一块“允许出错”的角落，因为大学社团最好的部分，从来不是完美，而是一群人手忙脚乱还愿意一起把事做完。' },
    ],
  },
  {
    id: 'canteen-hidden-menu',
    title: '食堂二楼的“隐藏菜单”，是打饭阿姨和熟客之间的暗号',
    categorySlug: 'canteen',
    categoryName: '食堂奇遇',
    excerpt:
      '同样一份套餐，有人端出来平平无奇，有人却撒了秘制辣椒油、多了一勺卤蛋。摸清规律后，我把食堂吃成了寻宝游戏。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20university%20canteen%20counter%20with%20trays%20of%20food%20and%20a%20friendly%20server%2C%20warm%20amber%20and%20cream%20palette%2C%20minimal%20editorial%20vector%20style%2C%20clean%20composition&width=800&height=600&seq=gt-canteen-menu-04&orientation=landscape',
    author: '干饭研究员·糖糖',
    date: '2026-09-02',
    readTime: 4,
    views: 9860,
    hot: false,
    featured: false,
    tags: ['食堂奇遇', '隐藏菜单', '校园美食'],
    content: [
      { type: 'p', text: '我们学校食堂二楼最右边那个窗口，是全校学生公认的“玄学窗口”。同样的十块钱套餐，每个人端到的样子都不一样。' },
      { type: 'h3', text: '摸清暗号的三个月' },
      { type: 'p', text: '我连着去了两周，终于发现规律：说“今天有点冷”的，会多一勺热汤；说“赶着去上课”的，会帮你打包得特别利落；而每次期末周出现的同学，碗底总会多埋一个卤蛋。' },
      { type: 'p', text: '这不是什么正式菜单，更像是阿姨和熟客之间心照不宣的默契。有同学专门做了份“隐藏菜单攻略”发在班级群里，第二天窗口前排起了长队。' },
      { type: 'quote', text: '“哪有什么隐藏菜单，就是看你们太累了，多给一点。”——二楼窗口阿姨' },
      { type: 'p', text: '现在每次路过那个窗口，我都会多说一句话。大学生的快乐有时候就这么简单：一句寒暄，换一碗热气腾腾的偏爱。' },
    ],
  },
  {
    id: 'campus-library-seat-war',
    title: '期末图书馆的“占座大战”，被一张手写道歉纸条化解了',
    categorySlug: 'campus',
    categoryName: '校园奇闻',
    excerpt:
      '抢座最激烈的那几天，有人用一本书占了一整天却从没出现，直到桌上出现了一张写得歪歪扭扭的纸条，故事走向突然温柔了起来。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20quiet%20university%20library%20reading%20room%20with%20long%20desks%20and%20warm%20lamps%2C%20terracotta%20and%20cream%20palette%2C%20minimal%20editorial%20vector%20style&width=800&height=600&seq=gt-library-seat-05&orientation=landscape',
    author: '图书馆常驻·小柒',
    date: '2026-08-30',
    readTime: 5,
    views: 13240,
    hot: true,
    featured: false,
    tags: ['校园奇闻', '图书馆', '期末周'],
    content: [
      { type: 'p', text: '每年期末，图书馆的座位都会变成稀缺资源。早上七点开门，六点半门口就排起了长队，大家抱着书和保温杯，像在参加一场无声的仪式。' },
      { type: 'h3', text: '那张没人认领的座位' },
      { type: 'p', text: '我常坐的窗边位置，被一本《计量经济学》占了整整三天。书页整整齐齐，却始终没有人来。第四天早上，那本书上多了一张纸条，字迹很急：“对不起，我妈妈住院了，我一直在医院，书先借座位一用，回来请你喝奶茶。”' },
      { type: 'p', text: '没有人再动那个位置。反倒是旁边几个同学默默把书挪到了自己这边，腾出更宽敞的空间，有人还留了一杯热豆浆和一张“加油”的便签。' },
      { type: 'quote', text: '“原来抢座的对手，也可能是同样在硬扛的人。”' },
      { type: 'p', text: '一周后那个座位的主人回来了，桌上堆了六杯奶茶，分给了周围所有默默帮她占住位置的陌生人。图书馆依旧安静，但那天很多人心里都暖了一下。' },
    ],
  },
  {
    id: 'dorm-midnight-hotpot',
    title: '宿舍违规煮火锅的第一次，也是最后一次',
    categorySlug: 'dorm',
    categoryName: '宿舍夜聊',
    excerpt:
      '四个人的小电锅、五包泡面和一袋丸子，本来以为是一场完美的深夜食堂，结果宿管阿姨的敲门声成了我们的背景音乐。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20tiny%20dorm%20room%20with%20a%20small%20electric%20pot%20of%20noodles%20steaming%20at%20night%2C%20warm%20orange%20glow%2C%20cream%20background%2C%20minimal%20editorial%20vector%20style&width=800&height=600&seq=gt-dorm-hotpot-06&orientation=landscape',
    author: '夜猫编辑·小满',
    date: '2026-08-27',
    readTime: 4,
    views: 10520,
    hot: false,
    featured: false,
    tags: ['宿舍夜聊', '深夜食堂', '室友'],
    content: [
      { type: 'p', text: '这是一件被我们反复复盘过很多次的事，每次讲起来都还会笑，但同时也心有余悸。' },
      { type: 'h3', text: '一切从一只小电锅开始' },
      { type: 'p', text: '室友从家里带回一只迷你电锅，声称“功率很小，绝对安全”。我们四个人的执行力在那一刻达到了巅峰：二十分钟内凑齐了泡面、丸子和一把青菜，宿舍瞬间变成深夜食堂。' },
      { type: 'p', text: '锅刚冒热气，走廊上就传来熟悉的脚步声。我们火速把锅塞进被子里，假装在看书。宿管阿姨推门进来，闻了闻空气，只说了一句：“下次去食堂，别在这儿弄，太危险。”然后转身走了。' },
      { type: 'quote', text: '“安全第一，故事第二，这锅从此封存。”' },
      { type: 'p', text: '那只电锅最后被我们郑重地收进了箱子最底层。现在回想起来，好吃的从来不是那锅面，而是四个人手忙脚乱又默契十足的样子。' },
    ],
  },
  {
    id: 'class-group-project',
    title: '小组作业六个人七个群，最后靠一份共享文档救了命',
    categorySlug: 'class',
    categoryName: '课堂八卦',
    excerpt:
      '从选题到交稿，我们的群越加越多、进度越来越慢，直到有人发起了一份“谁也别装死”的共享文档，奇迹发生了。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20students%20collaborating%20around%20a%20laptop%20with%20sticky%20notes%20and%20charts%2C%20warm%20terracotta%20and%20cream%20palette%2C%20minimal%20editorial%20vector%20style&width=800&height=600&seq=gt-class-group-07&orientation=landscape',
    author: '课堂观察员·老周',
    date: '2026-08-24',
    readTime: 5,
    views: 8720,
    hot: false,
    featured: false,
    tags: ['课堂八卦', '小组作业', '协作'],
    content: [
      { type: 'p', text: '“小组作业”这四个字，对大学生来说自带画面感：分工不明、进度成谜、DDL前夜全体上线。我们这次，直接把难度拉满。' },
      { type: 'h3', text: '六个群与一个共同目标' },
      { type: 'p', text: '为了讨论选题，我们建了三个群；为了对接数据，又建了两个；还有一个专门用来发表情包缓和气氛。结果就是，重要的信息散落在六个地方，谁都没信心说清楚进度。' },
      { type: 'p', text: '转机来自组长发的一份共享文档：左边是任务清单，右边是负责人和截止时间，最上面写着一行加粗的大字——“谁也别装死”。神奇的是，白纸黑字列出来之后，大家反而踏实了，三天内完成了百分之八十的内容。' },
      { type: 'quote', text: '“群可以乱加，文档不能少建。”' },
      { type: 'p', text: '我们最后拿了不错的分数，但更重要的是学会了一件事：比起热情，小组作业更需要清晰的边界和一点点幽默感。' },
    ],
  },
  {
    id: 'club-overnight-hike',
    title: '社团通宵拉练爬野山，山顶看到的日出值回所有脚痛',
    categorySlug: 'club',
    categoryName: '社团趣事',
    excerpt:
      '凌晨两点出发，二十个人打着手电筒、互相拽着往上爬，有人哭着说不走了，却在看到日出那一刻第一个喊出来。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20students%20hiking%20up%20a%20mountain%20at%20dawn%20with%20flashlights%2C%20warm%20sunrise%20orange%20and%20mint%20green%20palette%2C%20minimal%20editorial%20vector%20style&width=800&height=600&seq=gt-club-hike-08&orientation=landscape',
    author: '社团打工人·阿岩',
    date: '2026-08-21',
    readTime: 6,
    views: 11340,
    hot: false,
    featured: true,
    tags: ['社团趣事', '户外', '日出'],
    content: [
      { type: 'p', text: '户外社的年度保留项目是“看日出拉练”，报名的时候人人都很有精神，出发前一晚，群里一半的人在问“还去吗”。' },
      { type: 'h3', text: '凌晨两点的山路' },
      { type: 'p', text: '两点集合，二十个人打着手电筒上山。前一个小时还有说有笑，到了中段全是喘气声。有个女生坐在石头上哭着说真的走不动了，队长没有催她，只是把她的包背过来，陪她慢慢走。' },
      { type: 'p', text: '五点半，我们终于站上山顶。天边先是泛起一条橘色，然后整片云海被点亮。刚才还在哭的那位同学，是第一个喊出声的人。' },
      { type: 'quote', text: '“日出不会等谁，但同行的人会。”' },
      { type: 'p', text: '下山的时候大家都在吐槽腿疼，可当天晚上，群里已经有人在问明年的路线了。有些经历就是这样，身体的累会忘，一起扛过来的感觉不会。' },
    ],
  },
  {
    id: 'canteen-mystery-giver',
    title: '连续七天有人帮我付早餐钱，监控拍到的画面让我说不出话',
    categorySlug: 'canteen',
    categoryName: '食堂奇遇',
    excerpt:
      '那段时间我每天赶早八，结账时总被一句“已经付过了”拦住。我以为是系统出问题，调了记录才发现，是有人在默默做一件小事。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20breakfast%20counter%20in%20a%20university%20canteen%20with%20steaming%20baozi%20and%20soy%20milk%2C%20warm%20cream%20and%20amber%20palette%2C%20minimal%20editorial%20vector%20style&width=800&height=600&seq=gt-canteen-mystery-09&orientation=landscape',
    author: '干饭研究员·糖糖',
    date: '2026-08-18',
    readTime: 5,
    views: 14680,
    hot: true,
    featured: false,
    tags: ['食堂奇遇', '善意', '校园日常'],
    content: [
      { type: 'p', text: '那阵子我接了个早班值班，每天七点就到食堂，睡眼惺忪地买两个包子一杯豆浆，是支撑我起床的唯一动力。' },
      { type: 'h3', text: '“已经付过了”' },
      { type: 'p', text: '第一周我连续几次被收银员告知已经付过钱，我以为是扫码系统串单，跑去后台查记录，才发现每笔订单都是真实支付的，而且都来自同一张学生卡。' },
      { type: 'p', text: '顺着记录找到那张卡的主人，是隔壁学院一个我根本不认识的学长。他说那段时间在食堂看到我每天早上都在打哈欠，猜我大概很累，就想“顺手帮一下”，没打算说。' },
      { type: 'quote', text: '“举手之劳不值得说，你要是想还，就帮下一个需要的人。”' },
      { type: 'p', text: '后来我在食堂帮过三个忘带卡的同学。这个故事没有什么惊天反转，但每次想起来，都觉得校园里的人情味，就藏在这些没人拍摄的瞬间里。' },
    ],
  },
  {
    id: 'campus-express-station',
    title: '快递站的暖柜里，藏着一张写给错拿包裹的人的地图',
    categorySlug: 'campus',
    categoryName: '校园奇闻',
    excerpt:
      '双十一之后快递站像被打翻的积木堆，有人错拿了别人的包裹，却在里面发现了一张手绘地图，指向失主宿舍楼下的长椅。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20colorful%20parcel%20pickup%20station%20with%20stacks%20of%20cardboard%20boxes%20and%20a%20small%20hand%20drawn%20map%2C%20warm%20orange%20and%20cream%20palette%2C%20minimal%20editorial%20vector%20style&width=800&height=600&seq=gt-campus-express-10&orientation=landscape',
    author: '校园巡逻员·阿禾',
    date: '2026-08-15',
    readTime: 4,
    views: 9210,
    hot: false,
    featured: false,
    tags: ['校园奇闻', '快递站', '小温暖'],
    content: [
      { type: 'p', text: '双十一之后的一周，学校的快递站基本处于“人类文明遗迹”状态，纸箱堆成小山，找自己的包裹全靠缘分。' },
      { type: 'h3', text: '一个拿错的包裹' },
      { type: 'p', text: '有位同学回宿舍拆开包裹，发现里面不是自己买的东西，而是一整套考研资料。按照常理，大家通常会直接送回快递站，但她在箱子底部发现了一张手绘小地图，标注着“失主宿舍楼下第三张长椅”。' },
      { type: 'p', text: '她按图索骥找到长椅，把包裹放在那里，还压了一张便签：“书很重，应该是重要的事，祝你上岸。”第二天她路过，长椅上多了一袋橘子。' },
      { type: 'quote', text: '“有些默契不需要见面，也会准时送达。”' },
      { type: 'p', text: '后来这件事在学校的树洞里被讲了很多次，版本也越来越夸张，但核心一直是那句：在忙乱的地方，总有人愿意多走两步。' },
    ],
  },
  {
    id: 'dorm-roommate-quarrel',
    title: '和室友冷战两周后，我先开口说的那句话救了我们',
    categorySlug: 'dorm',
    categoryName: '宿舍夜聊',
    excerpt:
      '因为一台噪音很大的吹风机，我们整整两周没说话。后来我憋出一句特别笨的开场白，反而把矛盾解开了。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20two%20students%20sitting%20apart%20in%20a%20dorm%20room%20then%20talking%20calmly%2C%20soft%20terracotta%20and%20mint%20green%20palette%2C%20minimal%20editorial%20vector%20style%20about%20friendship&width=800&height=600&seq=gt-dorm-quarrel-11&orientation=landscape',
    author: '夜猫编辑·小满',
    date: '2026-08-12',
    readTime: 5,
    views: 7740,
    hot: false,
    featured: false,
    tags: ['宿舍夜聊', '室友关系', '成长'],
    content: [
      { type: 'p', text: '宿舍矛盾大多数时候都不来自什么大事，我们这次是因为一台噪音巨大的吹风机。' },
      { type: 'h3', text: '两周的沉默' },
      { type: 'p', text: '她习惯睡前吹头发，我第二天要早起，提醒了几次都没什么改善，最后一次我语气重了点，之后我们就进入了谁也不理谁的阶段。同一屋檐下，空气比图书馆还安静。' },
      { type: 'p', text: '冷战到第十天，我发现自己其实也睡不好——不是因为噪音，是因为那口气憋着不舒服。第十二天晚上她吹完头发，我憋出一句：“那个……吹风机是不是有点吵，我帮你问了隔壁，她们用的是静音款。”话一出口，我们俩都笑了。' },
      { type: 'quote', text: '“矛盾不可怕，可怕的是谁都不肯先递个台阶。”' },
      { type: 'p', text: '第二天她真的换了台静音吹风机，我请她喝了杯奶茶。后来我们约定：有意见当天说，不超过二十四小时。这条规矩我们守到了毕业。' },
    ],
  },
  {
    id: 'class-teacher-warmth',
    title: '那位被我们叫做“严师”的教授，期末给全班写了手写信',
    categorySlug: 'class',
    categoryName: '课堂八卦',
    excerpt:
      '他上课从不点名，却记得每个人的名字；作业批改严到不留情面，最后一节课却给每个人塞了一封手写信，教室安静了很久。',
    cover:
      'https://readdy.ai/api/search-image?query=flat%20illustration%20of%20a%20kind%20professor%20handing%20handwritten%20letters%20to%20students%20in%20a%20classroom%2C%20warm%20amber%20and%20cream%20editorial%20vector%20style%2C%20soft%20and%20hopeful%20mood&width=800&height=600&seq=gt-class-letter-12&orientation=landscape',
    author: '课堂观察员·老周',
    date: '2026-08-09',
    readTime: 5,
    views: 13460,
    hot: false,
    featured: true,
    tags: ['课堂八卦', '师生', '毕业季'],
    content: [
      { type: 'p', text: '选课系统里，那门课的评价常年两极分化：一半人说他“要求太严”，一半人说他“值回四年学费”。' },
      { type: 'h3', text: '严苛背后的记忆' },
      { type: 'p', text: '他从不点名，却能准确叫出每个人名字；作业改得极细，哪怕一个标点错误都会被圈出来。有同学被批注写满整页，当场差点哭出来。' },
      { type: 'p', text: '最后一节课，他没讲新课，而是从包里拿出一摞信封，一人一封。那是他手写的信，内容各不相同：有人被鼓励去做研究，有人被提醒别放弃写作，还有人被写了一句“你比你想象中更有耐心”。' },
      { type: 'quote', text: '“严是为了你们以后能扛事，信是怕你们误会我只在乎分数。”' },
      { type: 'p', text: '那天教室里特别安静，很多人把信夹进了笔记本。原来那些看似不近人情的严格，背后是一份很具体的期待。' },
    ],
  },
];